var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _m;
import { Vec3D } from "./vec3d";
export class Matrix3D {
    constructor(m) {
        _m.set(this, void 0);
        if (!m) {
            m = [
                [1, 0, 0, 0],
                [0, 1, 0, 0],
                [0, 0, 1, 0],
                [0, 0, 0, 1],
            ];
        }
        __classPrivateFieldSet(this, _m, m);
    }
    rotate(x, y, z) {
        let m = this.rotateX(x);
        m = m.rotateY(y);
        return m.rotateZ(z);
    }
    rotateY(rad) {
        const tm = new Matrix3D([
            [Math.cos(rad), 0, -Math.sin(rad), 0],
            [0, 1, 0, 0],
            [Math.sin(rad), 0, Math.cos(rad), 0],
            [0, 0, 0, 1],
        ]);
        return this.mul(tm);
    }
    rotateX(rad) {
        const tm = new Matrix3D([
            [1, 0, 0, 0],
            [0, Math.cos(rad), -Math.sin(rad), 0],
            [0, Math.sin(rad), Math.cos(rad), 0],
            [0, 0, 0, 1],
        ]);
        return this.mul(tm);
    }
    rotateZ(rad) {
        const tm = new Matrix3D([
            [Math.cos(rad), -Math.sin(rad), 0, 0],
            [Math.sin(rad), Math.cos(rad), 0, 0],
            [0, 0, 1, 0],
            [0, 0, 0, 1],
        ]);
        return this.mul(tm);
    }
    translate(v) {
        const tm = new Matrix3D([
            [1, 0, 0, v.x],
            [0, 1, 0, v.y],
            [0, 0, 1, v.z],
            [0, 0, 0, 1],
        ]);
        return this.mul(tm);
    }
    transform(v) {
        return new Vec3D(__classPrivateFieldGet(this, _m)[0][0] * v.x +
            __classPrivateFieldGet(this, _m)[0][1] * v.y +
            __classPrivateFieldGet(this, _m)[0][2] * v.z +
            __classPrivateFieldGet(this, _m)[0][3] * 1, __classPrivateFieldGet(this, _m)[1][0] * v.x +
            __classPrivateFieldGet(this, _m)[1][1] * v.y +
            __classPrivateFieldGet(this, _m)[1][2] * v.z +
            __classPrivateFieldGet(this, _m)[1][3] * 1, __classPrivateFieldGet(this, _m)[2][0] * v.x +
            __classPrivateFieldGet(this, _m)[2][1] * v.y +
            __classPrivateFieldGet(this, _m)[2][2] * v.z +
            __classPrivateFieldGet(this, _m)[2][3] * 1);
    }
    mul(other) {
        const a = __classPrivateFieldGet(this, _m);
        const b = __classPrivateFieldGet(other, _m);
        const m = new Array(4); // initialize array of rows
        for (var r = 0; r < 4; ++r) {
            m[r] = new Array(4); // initialize the current row
            for (var c = 0; c < 4; ++c) {
                m[r][c] = 0; // initialize the current cell
                for (var i = 0; i < 4; ++i) {
                    m[r][c] += a[r][i] * b[i][c];
                }
            }
        }
        return new Matrix3D(m);
    }
}
_m = new WeakMap();
